export enum SubscriptionStatus {
  IN_TRIAL = 'IN_TRIAL',
  FUTURE = 'FUTURE',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  PAUSED = 'PAUSED',
}
